<template>
  <SettingsPagePanel>
    <SettingsPagePanelHeader>
      <template #title>チーム管理</template>
      <template #right>
        <FlatButton @click="openAddTeamModal" :disabled="isLoading"
          >追加</FlatButton
        >
      </template>
    </SettingsPagePanelHeader>
    <ul v-if="!isLoading" :class="$style.list">
      <li v-for="team in teams" :key="team.guid" :class="$style.list__item">
        <div :class="$style.listItem">
          <router-link
            :to="{
              name: 'teamManagementSettingDetail',
              params: {
                teamManagementSettingId: team.guid,
                entranceGUID: entranceGUID,
              },
            }"
          >
            <p>{{ team.name }}</p>
          </router-link>
          <ButtonIconOnly
            :class="$style.deleteButton"
            title="削除する"
            @click.stop="deleteTeam(team.guid)"
            :disabled="isSubmitting"
          >
            <template #icon>
              <IconDustBox />
            </template>
          </ButtonIconOnly>
        </div>
      </li>
    </ul>
    <AddTeamControlledModal>
      <AddTeamModal
        @close="closeAddTeamModal"
        @createTeam="createTeamWrapped"
      />
    </AddTeamControlledModal>
  </SettingsPagePanel>
</template>

<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'
import ButtonIconOnly from '@/components/atoms/ButtonIconOnly.vue'
import IconDustBox from '@/components/icons/IconDustBox.vue'
import AddTeamModal from './AddTeamModal.vue'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import { useTeamManagement } from './composables/useTeamManagement'
import { useModal } from '@/hooks/useModal'
import { useEntranceGUIDParam } from '@/features/entrance/useEntranceGUIDParam'

const { entranceGUID } = useEntranceGUIDParam({ must: true })

const { teams, isLoading, isSubmitting, createTeam, deleteTeam } =
  useTeamManagement()

const createTeamWrapped = (teamName: string) => {
  createTeam(teamName).then(closeAddTeamModal)
}

const addTeamModal = useModal()
const AddTeamControlledModal = addTeamModal.ControlledModal

const openAddTeamModal = () => addTeamModal.openModal()
const closeAddTeamModal = () => addTeamModal.closeModal()
</script>

<style lang="scss" module>
.list {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &:nth-child(n + 2) {
    margin-top: 12px;
  }

  &__item {
    border: 1px solid $color-border-low-emphasis;
    border-radius: $border-radius-v2-base;
    padding: 16px;

    &:hover {
      background-color: $color-surface-accent-primary-light;
    }
  }
}

.listItem {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.deleteButton {
  &:hover {
    color: $color-caution-accent;
  }
}
</style>
